module.exports = __webpack_public_path__ + "img/logo.5c46e09a.svg";